// ─── Achat à la carte par POOL DE POINTS (Core, pur) ───────────────
// Modèle validé par Cédric le 19/08 sur une démo cliquable : chaque forfait
// inclut un budget de points offerts ; chaque fonction/plafond « à la carte »
// coûte un poids en points (poidsDe(), fonctionnalites.js) ; au-delà du
// budget inclus, un tarif s'applique par PALIER DE POINTS — pas un prix par
// fonction, un seul barème à régler quel que soit le nombre de fonctions du
// catalogue.
//
// Deux mécanismes PARTAGENT le même pool mais ont des FORMES différentes :
//   • fonctions (binaires) → users.fonctionnalitesAchetees[cle] = dateFin|null
//     (déjà lu par le moteur, cf. fonctionnalites.js:fonctionInclusePlan)
//   • plafonds (quantité)  → users.quotasAchetes[cle] = n (bonus additif,
//     cf. jetons.js:dotation/dotationEspaces/maxTypeEffectif)
// L'écriture RÉELLE de ces deux champs est réservée à l'administration
// (firestore.rules, même régime que `plan`) : l'utilisateur ne fait que
// DÉPOSER une demande (cf. pointsALaCarteService.js), comme pour un
// changement de forfait.
//
// Aucune dépendance Firestore/UI ici : testable et réutilisable.

export const POINTS_DEFAUT = 0;
// Combien de points un forfait inclut GRATUITEMENT. Réglage en base
// (config/fonctionnalites.plans[plan].pointsInclus), même grammaire que
// `maxEspaces`/`maxParType`. Défaut 0 (pas de budget tant que rien n'est
// réglé) — contrairement au palier, un pool non configuré ne doit PAS être
// permissif : il donnerait un budget infini par accident.
export function pointsInclusDePlan(cfg, plan) {
  const n = cfg?.plans?.[plan]?.pointsInclus;
  return Number.isFinite(n) ? n : POINTS_DEFAUT;
}

// Barème : liste [{ max, prix }] triée croissant sur `max` ; `max: null` =
// dernier palier (tout ce qui dépasse). Repli si `config/pointsALaCarte`
// n'existe pas encore — mêmes valeurs que la démo validée par Cédric.
export const BAREME_DEFAUT = [
  { max: 2, prix: 0.99 },
  { max: 5, prix: 1.99 },
  { max: 9, prix: 3.49 },
  { max: 14, prix: 5.99 },
  { max: null, prix: 8.99 },
];

// Prix mensuel pour `n` points AU-DELÀ du budget inclus (0 si n <= 0).
export function prixDePoints(bareme, n) {
  if (!n || n <= 0) return 0;
  const b = (Array.isArray(bareme) && bareme.length) ? bareme : BAREME_DEFAUT;
  const palier = b.find(x => x.max == null || n <= x.max);
  return palier ? palier.prix : b[b.length - 1].prix;
}

// Une demande à la carte est en cours ? `achatsDemande` = { fonctions:[cle],
// quotas:{[cle]:n} } — vide de sens si les deux collections sont vides.
export function aDemandeAchats(u) {
  const d = u?.achatsDemande;
  if (!d) return false;
  return (Array.isArray(d.fonctions) && d.fonctions.length > 0)
    || Object.keys(d.quotas || {}).length > 0;
}

// Poids TOTAL d'une sélection { fonctions:[{cle,poids}], quotas:{cle:{n,poids}} }
// — l'appelant a déjà résolu poidsDe() pour chaque entrée (le Core reste pur,
// il ne connaît pas le catalogue ni la config ici).
export function poidsSelection(selection) {
  const f = (selection?.fonctions || []).reduce((s, x) => s + (x.poids || 0), 0);
  const q = Object.values(selection?.quotas || {}).reduce((s, x) => s + (x.n || 0) * (x.poids || 0), 0);
  return f + q;
}
